// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Box, styled } from '@material-ui/core';

export const LeftBorderBox = styled(Box)(({ theme }) => ({
  borderLeft: `1px solid ${theme.palette.text.disabled}`,
}));
